<template>
  <div class="container editTariff">
    <h1 class="title">
      <span class="icon clickable returnIcon" @click="goBack">
        <i class="mdi mdi-chevron-left"></i>
      </span>

      {{ installation.name }}
    </h1>

    <h2 class="subtitle">{{ $t("installation.tariff") }}</h2>

    <div class="columns is-multiline">
      <div class="column is-2">
        <b-field :label="$t('installation.currency')">
          <b-select :placeholder="$t('form.select')" v-model="form.currency">
            <option value="GBP">{{ $t("currency.gbp") }}</option>
            <option value="USD">{{ $t("currency.usd") }}</option>
            <option value="EUR">{{ $t("currency.eur") }}</option>
            <option value="RUB">{{ $t("currency.rub") }}</option>
          </b-select>
        </b-field>
      </div>
      <!--      <div class="column is-2">-->
      <!--        <b-field :label="$t('installation.costLimit')">-->
      <!--          <b-input v-model.number="form.cost_limit"></b-input>-->
      <!--        </b-field>-->
      <!--      </div>-->
      <div class="column is-2 is-offset-8 is-vertical-center">
        <button
          class="button is-primary"
          :disabled="!isFormValid"
          @click="save"
        >
          {{ $t("buttons.save") }}
        </button>
      </div>
      <div v-for="hour in hours" class="column is-3">
        <b-field :label="hour + ' - ' + (hour + 1)">
          <b-input v-model.number="form.tariff[hour]"></b-input>
        </b-field>
      </div>
    </div>
    <br /><br />
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import zapp from "@/util/zapp";

export default {
  name: "installation-tariff",

  data() {
    return {
      form: {
        currency: "",
        tariff: [],
        cost_limit: 0,
      },
    };
  },

  computed: {
    ...mapState("user", {
      user: "current",
    }),

    ...mapState("installations", {
      installation: "current",
      tariff: "currentTariff",
    }),

    hours: () => zapp.range(0, 23),

    isFormValid: function () {
      return (
        this.form.currency.length > 0 &&
        typeof this.form.cost_limit === "number" &&
        this.form.cost_limit > 0 &&
        this.form.tariff.filter((field) => {
          return (
            (typeof field === "number" && field < 0) ||
            (typeof field === "string" && field.length === 0)
          );
        }).length === 0
      );
    },
  },

  methods: {
    goBack: function () {
      this.$router.push("/installations/" + this.installation[".key"]);
    },

    ...mapActions("installations", {
      setInstallation: "setCurrent",
      updateTariff: "updateTariff",
    }),

    save: function () {
      this.updateTariff({
        installation: this.installation,
        form: this.form,
      }).then(() => this.goBack());
    },

    loadForm: function () {
      this.form.currency =
        this.installation.currency !== undefined
          ? this.installation.currency
          : "EUR";
      this.form.cost_limit = this.installation.cost_limit;
      this.form.tariff = this.tariff.slice(0); //CLONE TARIFF
    },
  },

  mounted() {
    this.setInstallation(this.$route.params.id)
      .then(() => {
        this.loadForm();
      })
      .catch(() => {
        this.$router.push("/installations");
      });
  },
};
</script>

<style lang="scss" scoped>
.container {
  max-width: 100%;
}

.editTariff {
  padding: 0 2rem 2rem;
}

h1.title {
  margin: 3rem 0 5rem;
}
</style>
